export default __webpack_public_path__ + "static/media/headshot.f98ae908.jpeg";